import React from "react";
import ListSubheader from "@mui/material/ListSubheader";


const TagMovingAverageHeader = () => {
  return (
    <ListSubheader
      sx={{
        fontSize: "0.75rem",
        fontWeight: "bolder",
        lineHeight: "1rem",
        my: "0.25rem",
        borderBottom: `2px solid`,
      }}
    >
      Moving Average (10 Samples)
    </ListSubheader>
  );
};

export default TagMovingAverageHeader;
